// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { FileInfoResponse } from './file-info-response';

// @ts-ignore
import { MessageParticipantNameResponse } from './message-participant-name-response';

/** See com.rev360.pms.api.controller.messaging.ForwardDataResponse */
/* istanbul ignore next */
@GandalfModel
export class ForwardDataResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Date })
	createdOn!: Date | null;

	@GandalfProperty({ designType: Number })
	forwardingMessageParticipantId!: number;

	@GandalfProperty({ designType: String })
	messageContent!: string | null;

	@GandalfArray(FileInfoResponse)
	messageFiles!: FileInfoResponse[];

	@GandalfProperty({ designType: Number })
	messageId!: number;

	@GandalfProperty({ designType: MessageParticipantNameResponse })
	originalMessageSender!: MessageParticipantNameResponse;

	@GandalfProperty({ designType: Number })
	parentMessageId!: number | null;

	@GandalfProperty({ designType: Number })
	rootMessageId!: number | null;

	@GandalfProperty({ designType: String })
	subject!: string;

}
